(function () {
  let cartBubbleContainer = null;

  function getCartBubble() {
    if (!cartBubbleContainer) {
      cartBubbleContainer = document.querySelector(".header--cart");
    }
    return cartBubbleContainer;
  }

  document.addEventListener("DOMContentLoaded", () => {
    const container = getCartBubble();
    if (!container) return;
    container.style.pointerEvents = "none";
  })
  document.addEventListener('rebuy.loaded', (event) => {
    const container = getCartBubble();
    if (!container) return;
    container.style.pointerEvents = null;
});
  document.addEventListener("rebuy:cart.change", (event) => {
    const cart = event.detail.cart.cart;
    const container = getCartBubble();
    if (!container || !cart || !cart.item_count) return;
    container.dataset.cartCount = cart.item_count;
  });
})();